import * as React from "react";

function SvgHome(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 48 48" ref={svgRef} {...props}><path d="M24 0a2 2 0 00-1.4.57L.785 18.414l-.074.059-.074.062A2 2 0 002 22h2v22a4 4 0 004 4h32a4 4 0 004-4V22h2a2 2 0 001.363-3.465l-.031-.023a1.88 1.88 0 00-.137-.114L44 15.785V8a2 2 0 00-2-2h-2a2 2 0 00-2 2v2.879L25.355.535A2 2 0 0024 0zm6 26h8v16h-8z" fill="currentColor" /></svg>;
}

const ForwardRef = React.forwardRef(SvgHome);
export default ForwardRef;